import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';
import { Calendar } from '@vk-hr-tek/core/calendar';

import { WidgetSurveyItem } from '@app/gen/dashboard';

@injectable()
export class SurveysWidgetListMapper {
  constructor(
    private format: FormatService,
    private calendar: Calendar,
  ) {}

  public processSurveysList(item: WidgetSurveyItem) {
    return {
      id: item.id,
      coverAttId: item.cover_att_id,
      isAnonymous: item.is_anonymous,
      showResult: item.show_results,
      title: item.title,
      completedAt: this.formatSurveysDate(
        this.formatSurveysExpired(item.completed_at),
        item.completed_at,
      ),
      category: item.category,
    };
  }

  private formatSurveysExpired(dateString?: string): boolean {
    return dateString ? new Date(dateString) < new Date() : false;
  }

  private formatSurveysDate(
    isSurveyExpired: boolean,
    dateString?: string,
  ): string {
    if (!dateString) {
      return 'Срок прохождения не ограничен';
    }

    const date = new Date(dateString);

    if (!this.calendar.isValidDate(date)) return dateString;

    if (isSurveyExpired) {
      return 'Истек период прохождения';
    }

    return `До ${new Intl.DateTimeFormat('ru-RU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
      .format(date)
      .split('г. в')
      .join(' ')}`;
  }
}
